<vectronic-card [title]="'Downgrade Permission'" [displayClose]="true" (closed)="dialogRef.close()">
  <ng-container body>
    <mat-dialog-content class="dialog-body">
      <p class="label">{{ text }}</p>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-button-container">
      <button mat-button (click)="cancel()" color="warn">
        <mat-icon>cancel</mat-icon>
        Cancel
      </button>
      <button mat-button color="accent" (click)="confirm()">
        <mat-icon>send</mat-icon>
        Proceed
      </button>
    </mat-dialog-actions>
  </ng-container>
</vectronic-card>
